var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$i18n.t("common.SKU_EAN_Encoding"),
                  clearable: ""
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleCurrentChange(1)
                  }
                },
                model: {
                  value: _vm.listQuery.idFuzzy,
                  callback: function($$v) {
                    _vm.$set(_vm.listQuery, "idFuzzy", $$v)
                  },
                  expression: "listQuery.idFuzzy"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticClass: "input-width",
                  attrs: {
                    placeholder: _vm.$i18n.t("common.Countrieslisted"),
                    clearable: ""
                  },
                  model: {
                    value: _vm.listQuery.shelfCountryCode,
                    callback: function($$v) {
                      _vm.$set(_vm.listQuery, "shelfCountryCode", $$v)
                    },
                    expression: "listQuery.shelfCountryCode"
                  }
                },
                _vm._l(_vm.dictionary.country, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticClass: "input-width",
                  attrs: {
                    placeholder: _vm.$i18n.t("common.state"),
                    clearable: ""
                  },
                  model: {
                    value: _vm.listQuery.effectShelf,
                    callback: function($$v) {
                      _vm.$set(_vm.listQuery, "effectShelf", $$v)
                    },
                    expression: "listQuery.effectShelf"
                  }
                },
                _vm._l(_vm.dictionary.state, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-cascader", {
                ref: "goodsClassCascader",
                attrs: {
                  placeholder: _vm.$t("common.Pleaseselectacategory"),
                  options: this.classifyTree,
                  props: {
                    checkStrictly: true,
                    value: "goodsClassifyId",
                    label: "title",
                    children: "children"
                  },
                  "show-all-levels": false,
                  clearable: ""
                },
                on: { change: _vm.handleCascaderChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  staticStyle: { "margin-left": "10px" },
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleCurrentChange(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$i18n.t("common.query")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  staticStyle: { "margin-left": "10px" },
                  attrs: {
                    icon: "el-icon-search",
                    type: "primary",
                    size: "small"
                  },
                  on: { click: _vm.cleanQuery }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$i18n.t("common.Reset")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { margin: "10px 0px 10px 20px" },
              attrs: { type: "success" },
              on: { click: _vm.openAddBindGoodsForm }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$i18n.t("common.Add")) +
                  "\n            "
              )
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "upload-btn",
              staticStyle: { margin: "10px 0px 10px 20px" },
              attrs: { type: "success", loading: _vm.loading }
            },
            [
              _vm._v(
                "   " +
                  _vm._s(_vm.$i18n.t("common.BatchInput")) +
                  "\n\n                "
              ),
              _c("div", { attrs: { id: "clone_input" } }, [
                _c("input", {
                  ref: "importFile",
                  staticClass: "upload-btn-file",
                  attrs: { type: "file", accept: _vm.accept },
                  on: { change: _vm.handleImport }
                })
              ])
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { margin: "10px 0px 10px 20px" },
              attrs: { type: "success" },
              on: { click: _vm.downloadTemplate }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$i18n.t("common.ImportTemplateDownload")) +
                  "\n            "
              )
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { margin: "10px 0px 10px 100px", float: "right" },
              on: { click: _vm.batchRemove }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$i18n.t("common.BatchRemoval")) +
                  "(" +
                  _vm._s(_vm.batchRemoveNum) +
                  ")\n            "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableData",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pageData.list,
            height: "500",
            border: "",
            "row-key": "goodsId",
            "default-expand-all": "",
            "header-cell-style": { background: "#EAEEF9", color: "#32353a" },
            "row-key": _vm.getRowKey,
            "tree-props": {
              children: "packageQtyList",
              hasChildren: "hasChildren"
            }
          },
          on: { select: _vm.onSelect, "select-all": _vm.onSelectAll }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsId",
              label: _vm.$i18n.t("common.ProductID"),
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsCode",
              label: _vm.$i18n.t("common.SKU_EAN_Encoding"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v("SKU:" + _vm._s(scope.row.sku))]),
                    _c("br"),
                    _c("span", [_vm._v("EAN:" + _vm._s(scope.row.barCode))]),
                    _c("br"),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$i18n.t("common.coding")) +
                          ":" +
                          _vm._s(scope.row.goodsCode)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "imageUrl",
              label: _vm.$i18n.t("common.Productimage1"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.imageUrl
                      ? _c("el-image", {
                          staticStyle: { height: "100px" },
                          attrs: {
                            src: _vm.ossHost + scope.row.imageUrl,
                            fit: "fill"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "packageQuantity",
              label: _vm.$i18n.t("common.PackingQuantity"),
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$i18n.t("common.ProductName"),
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "treeList",
              label: _vm.$i18n.t("common.Category"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.treeList, function(item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _vm._l(item.parents, function(item2, index2) {
                          return _c("span", { key: index2 }, [
                            _c("span", [_vm._v(_vm._s(item2.title) + ">")])
                          ])
                        }),
                        _c("span", [_vm._v(_vm._s(item.title))])
                      ],
                      2
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsSpecials",
              label: _vm.$i18n.t("common.Countrieslisted"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.goodsSpecials, function(s, index) {
                    return _c("span", { key: index }, [
                      s.shelf
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$dict.getDictValue(
                                  "countrys",
                                  s.countryCode
                                )
                              )
                            ),
                            _c("br")
                          ])
                        : _vm._e()
                    ])
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsSpecials",
              label: _vm.$i18n.t("common.inventory"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.goodsSpecials, function(s, index) {
                    return s.shelf && s.ecomRemainQty
                      ? _c("span", { key: index }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$dict.getDictValue(
                                  "countrys",
                                  s.countryCode
                                )
                              ) +
                              ":" +
                              _vm._s(s.ecomRemainQty)
                          ),
                          _c("br")
                        ])
                      : _vm._e()
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsSpecials",
              label: _vm.$t("common.ProductPromotion"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.isShowGoodsPromotion(
                      scope.row.promotionRuleCountrys,
                      "NEW"
                    )
                      ? _c(
                          "span",
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "text-align": "left",
                                  display: "block"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("common.NewUserPromotion"))
                                ),
                                _c("br")
                              ]
                            ),
                            _vm._l(scope.row.promotionRuleCountrys, function(
                              promotion,
                              index
                            ) {
                              return promotion.userType == "NEW"
                                ? _c("span", { key: index }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$dict.getDictValue(
                                            "countrys",
                                            promotion.countryCode
                                          )
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.getPromotionGoodsPrice(
                                            promotion,
                                            scope.row.prices
                                          )
                                        )
                                    ),
                                    _c("br")
                                  ])
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isShowGoodsPromotion(
                      scope.row.promotionRuleCountrys,
                      "OLD"
                    )
                      ? _c(
                          "span",
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "text-align": "left",
                                  display: "block"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("common.RegularUserPromotion"))
                                ),
                                _c("br")
                              ]
                            ),
                            _vm._l(scope.row.promotionRuleCountrys, function(
                              promotion,
                              index
                            ) {
                              return promotion.userType == "OLD"
                                ? _c("span", { key: index }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$dict.getDictValue(
                                            "countrys",
                                            promotion.countryCode
                                          )
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.getPromotionGoodsPrice(
                                            promotion,
                                            scope.row.prices
                                          )
                                        )
                                    ),
                                    _c("br")
                                  ])
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    !scope.row.promotionRuleCountrys ||
                    scope.row.promotionRuleCountrys.length == 0
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t(
                                "common.ThereAreCurrentlyNoProductPromotions"
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "prices",
              label: _vm.$i18n.t("common.fixedprice"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.prices, function(s, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$dict.getDictValue("countrys", s.countryCode)
                          ) +
                          ":"
                      ),
                      s.resultPrice
                        ? _c("span", [_vm._v(_vm._s(s.resultPrice.toFixed(2)))])
                        : _vm._e(),
                      _c("br")
                    ])
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "shelf",
              label: _vm.$i18n.t("common.state"),
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.shelf == true
                      ? _c("span", { staticStyle: { color: "#46a8a0" } }, [
                          _vm._v(_vm._s(_vm.$i18n.t("common.Listed")))
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.$i18n.t("common.Notlisted")))
                        ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "enCustomParameterNameList",
              label: _vm.$i18n.t("common.SearchParameter"),
              width: "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.enCustomParameterNameList, function(
                    s,
                    index
                  ) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticStyle: {
                          "margin-left": "8px",
                          "margin-top": "8px"
                        },
                        attrs: { type: s }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(s) +
                            "\n                    "
                        )
                      ]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$i18n.t("common.operation"), align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-inner-button",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleRemoveGoods(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$i18n.t("common.remove")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.size,
              layout: "total, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        ],
        1
      ),
      _vm.addBindGoodsVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$i18n.t("common.Selectproduct"),
                visible: _vm.addBindGoodsVisible,
                "close-on-click-modal": false,
                width: "1200px",
                "append-to-body": true
              },
              on: {
                "update:visible": function($event) {
                  _vm.addBindGoodsVisible = $event
                },
                close: function($event) {
                  return _vm.closeAddBindGoodsForm()
                }
              }
            },
            [
              _c("addBindGoods", {
                ref: "addBindGoods",
                attrs: { customParameterId: _vm.customParameterId }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }